// extracted by mini-css-extract-plugin
export default {"container":"BudgetTaskField_container__W-poC","titleStrict":"BudgetTaskField_titleStrict__J6If7","payWrapper":"BudgetTaskField_payWrapper__QRMja"};